/* eslint-disable */
import React from 'react';

import Card, { CardProps } from '@mui/material/Card';

const MapCard = (props: CardProps) => <Card {...props} />;

export default MapCard;
